module.exports = __webpack_public_path__ + "static/img/item_back_bg_blue.e7d44201.svg";